module.exports = {"id":"203872","name":"Gabriel Hauche","rating":"73","photo":"./data/images/photos/2/203872.png","club":{"name":"Toluca","logo":"./data/images/clubs/Toluca.png"},"positions":["BU","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GabrielHauche0.json
// module id = 1511
// module chunks = 0